module.exports = __webpack_public_path__ + "static/media/speaker1-ProfDrGuanHuaHuang.ad7370d2.jpg";